import type { IMealVoucherSupplierResponse } from 'types/meal-vouchers';

import type { ValueOf } from 'types/utility';

// Constants

export const PAYMENT_METHOD_TYPES = {
  MONEY: 'money',
  MEAL_VOUCHER: 'meal-voucher',
  POINTS: 'points',
} as const;

export type PaymentMethodType = ValueOf<typeof PAYMENT_METHOD_TYPES>;

// Responses

export type IPaymentMethod =
  IMoneyPaymentMethod
  | IMealVoucherPaymentMethod
  | IPointsPaymentMethod;

export type IPayment =
  IMoneyPayment
  | IMealVoucherPayment
  | IPointsPayment;

export interface IGenericPaymentMethod {
  eligible: boolean,
  checkoutEnabled: boolean,
  //
  amount?: number,
  code: string,
  name?: string,
  instructions?: string,
  //
  uri?: string
}

export interface IMoneyPaymentMethod extends IGenericPaymentMethod {
  type: typeof PAYMENT_METHOD_TYPES.MONEY,
  payment: IPointsPayment,
  fee?: IPaymentFee
}

export interface IMealVoucherPaymentMethod extends IGenericPaymentMethod {
  type: typeof PAYMENT_METHOD_TYPES.MEAL_VOUCHER,
  mealVoucher: IMealVoucherSupplierResponse,
  payment?: IMealVoucherPayment
}

export interface IPointsPaymentMethod extends IGenericPaymentMethod {
  type: typeof PAYMENT_METHOD_TYPES.POINTS,
  payment: IPointsPayment
}

// --- Payment

export interface IMoneyPayment {
  type: typeof PAYMENT_METHOD_TYPES.MONEY,
  id: number,
  amount: number,
  currency: string
}

export interface IMealVoucherPayment {
  type: typeof PAYMENT_METHOD_TYPES.MEAL_VOUCHER,
  id: number,
  amount: number,
  currency: string
}

export interface IPointsPayment {
  type: typeof PAYMENT_METHOD_TYPES.POINTS,
  id: number,
  amount: number,
  currency: string
}

// --- Payment Fee

export interface IPaymentFee {
  amount: number,
  currency: string
}
